import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHero = ({ eyebrow, title, subtitle, crumbs = [] }) => {
  return (
    <section className="relative bg-leduro-navy text-white overflow-hidden">
      <div className="absolute inset-0 grid-lines opacity-25 pointer-events-none" />
      <div
        className="absolute -right-32 -top-32 h-80 w-80 rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(243,112,33,0.18), transparent 65%)" }}
      />
      <div className="relative leduro-container py-16 md:py-24">
        <nav className="flex items-center gap-2 text-xs text-white/60 mb-6" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-leduro-orange" data-testid="breadcrumb-home">
            Home
          </Link>
          {crumbs.map((c, i) => (
            <React.Fragment key={i}>
              <ChevronRight className="h-3 w-3" />
              {c.to ? (
                <Link to={c.to} className="hover:text-leduro-orange">{c.label}</Link>
              ) : (
                <span className="text-white">{c.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
        {eyebrow && (
          <span className="leduro-eyebrow text-leduro-orange">— {eyebrow}</span>
        )}
        <h1 className="mt-3 font-heading font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl text-balance max-w-3xl leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-white/75 text-base md:text-lg max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
